module.exports = __webpack_public_path__ + "static/media/amigoo_error.4707e09c.svg";